import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
export default class User {
  view(vnode) {
    const {
      user
    } = vnode.attrs;
    return m(Link, {
      href: app.route.user(user)
    }, [m(Avatar, {
      user
    }), ' ', username(user)]);
  }
}
flarum.reg.add('clarkwinkelmann-catch-the-fish', 'forum/components/User', User);